var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTime = function SvgTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 4.24335L14.9543 0.7096L13.7763 2.1121L17.9884 5.64585L19.1663 4.24335ZM6.22301 2.10752L5.04509 0.705017L0.833008 4.23877L2.01092 5.64127L6.22301 2.10752ZM10.458 6.33335H9.08301V11.8334L13.4326 14.4504L14.1247 13.3184L10.458 11.1459V6.33335ZM9.99509 2.66668C5.43467 2.66668 1.74967 6.36085 1.74967 10.9167C1.74967 15.4725 5.43467 19.1667 9.99509 19.1667C14.5555 19.1667 18.2497 15.4725 18.2497 10.9167C18.2497 6.36085 14.5555 2.66668 9.99509 2.66668ZM9.99967 17.3334C6.45676 17.3334 3.58301 14.4596 3.58301 10.9167C3.58301 7.37377 6.45676 4.50002 9.99967 4.50002C13.5426 4.50002 16.4163 7.37377 16.4163 10.9167C16.4163 14.4596 13.5472 17.3334 9.99967 17.3334Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time.74f7a175.svg";
export { ForwardRef as ReactComponent };